import React, { Component, Fragment } from 'react'
import * as R from 'ramda'
import { observer } from 'mobx-react'

import Select from '../../form/Select'
import Input from '../../form/Input'
import { getTitle } from '../../../utils/QuestionHelper'
import Button from '../../../UniformComponents/Button'

@observer
class ChartMath extends Component {
    constructor(props) {
        super(props)
        this.state = {
            chosenQuestions: [],
            addingQuestion: false,
            newQuestion: '',
            formulaScope: {},
            testing: false,
        }
    }

    componentDidMount() {
        const { question, chart, questionTitle } = this.props

        const allowedQuestions = this.allowedQuestions()

        const variableQuestions = chart.variables
            ? Object.keys(chart.variables).map((v) => chart.variables[v].split('|')[0])
            : []

        const addedQuestions = allowedQuestions
            .filter((aQ) => variableQuestions.includes(aQ.value.questionId))

        const startingOptions = this.formatOptions(question)
        this.setState({
            chosenQuestions: [
                ...addedQuestions,
                {
                    label: questionTitle,
                    value: { questionId: question.id, options: startingOptions },
                },
            ],
        })
    }

    getFormOptionTitle = (option) => {
        const { store } = this.props
        const { survey, surveyLocale } = store
        const { defaultLocale } = survey.metadata

        return getTitle({
            content: option.question.content.shortTitle,
            locale: surveyLocale,
            defaultLocale,
        }).text
    }

    formatOptions =(question) => {
        const { getOptionTitle, getQuestionTitle } = this.props
        switch (question.question.questionTypeCode) {
            case ('NF'):
                return question.question.optionSet.map((option) => ({
                    label: `${getQuestionTitle(question)} - ${this.getFormOptionTitle(option)}`,
                    value: `${question.id}|${option.question.id}`,
                }))
            case ('PC'):
                return question.question.optionSet.options.map((option) => ({
                    label: `${getQuestionTitle(question)} - ${getOptionTitle(option, question)}`,
                    value: `${question.id}|${option.id}`,
                }))
            case ('RD'):
                return [{ label: getQuestionTitle(question), value: question.id }]
            case ('TB'):
                return question.question.optionSetY.options
                    .map((option) => (
                        {
                            label: `${getQuestionTitle(question)} - ${getOptionTitle(option, question)}`,
                            value: `${question.id}|${option.id}`,
                        }
                    ))
            default:
                return [{ label: getQuestionTitle(question), value: question.id }]
        }
    }

    allowedQuestions = () => {
        const { pages, question, getQuestionTitle } = this.props
        const { chosenQuestions } = this.state
        const allQuestions = pages.map((p) => p.questions.slice()).flat(2)
        const allowedQuestions = allQuestions
            .slice(0, allQuestions.findIndex((q) => q.id === question.id))

        return allowedQuestions
            .filter((aQ) => (
                !chosenQuestions.some((cQ) => cQ.value.questionId === aQ.id)
                    && R.pathOr(true, ['question', 'optionSet', 'hasNumericCodes'], aQ)
                    && R.pathOr(true, ['question', 'optionSetX', 'hasNumericCodes'], aQ)
                    && ['NF', 'PC', 'RD', 'TB', 'I'].includes(aQ.question.questionTypeCode)
            ))
            .map((q) => ({
                label: getQuestionTitle(q),
                value: { questionId: q.id, options: this.formatOptions(q) },
            }))
    }

    getVariableKey = () => {
        const { chart } = this.props
        if (!chart.variables) return 'A'
        const currentVariableKeys = Object.keys(chart.variables)
        const numCurrentVariables = currentVariableKeys.length
        if (!numCurrentVariables) return 'A'

        const currentRemainder = currentVariableKeys[numCurrentVariables - 1].length === 2
            ? currentVariableKeys[numCurrentVariables - 1][1].charCodeAt(0) - 64
            : currentVariableKeys[numCurrentVariables - 1].charCodeAt(0) - 64
        const currentquotient = currentVariableKeys[numCurrentVariables - 1].length === 2
            ? currentVariableKeys[numCurrentVariables - 1][0].charCodeAt(0) - 64
            : 0

        const newCountBase = currentRemainder + (currentquotient * 26)

        const quotient = Math.floor(newCountBase / 26)
        const remainder = (newCountBase % 26) + 1
        const prefix = quotient ? String.fromCharCode(96 + quotient).toUpperCase() : ''
        const variableLetter = String.fromCharCode(96 + remainder).toUpperCase()

        return `${prefix}${variableLetter}`
    }

    changeFormulaScope = (variable, value) => {
        const { formulaScope } = this.state
        if (!value.length) {
            const formulaScopeCopy = R.clone(formulaScope)
            delete formulaScopeCopy[variable]
            this.setState({ formulaScope: formulaScopeCopy })
            return
        }
        this.setState((prevState) => ({
            formulaScope: {
                ...prevState.formulaScope,
                [variable]: value,
            },
        }))
    }

    renderVariableMapping = () => {
        const { chart } = this.props
        const { chosenQuestions, testing, formulaScope } = this.state
        const nextVariableKey = this.getVariableKey()
        const options = chosenQuestions.map((q) => q.value.options).flat()
        return (
            <div className="varMap">
                {chart.variables && Object.keys(chart.variables).length
                    ? Object.keys(chart.variables).map((variableKey) => (
                        <div key={variableKey} className="mapping" style={{ display: 'flex', marginBottom: '5px' }}>
                            <input disabled value={variableKey} style={{ width: '50px', textAlign: 'center' }} />
                            {!testing ? (
                                <Select
                                    options={options}
                                    defaultValue={chart.variables[variableKey]}
                                    onBlur={(o) => chart.setVariable(variableKey, o.value)}
                                />
                            )
                                : (
                                    <Input
                                        onBlur={(i) => this.changeFormulaScope(variableKey, i.value)}
                                        defaultValue={formulaScope[variableKey]}
                                    />
                                )}
                        </div>
                    ))
                    : null}
                {!testing
                && (
                    <div className="mapping" style={{ display: 'flex' }}>
                        <input disabled value={nextVariableKey} style={{ width: '50px', textAlign: 'center' }} />
                        <Select
                            options={options}
                            placeholder="Option..."
                            value={null}
                            onBlur={(o) => chart.setVariable(nextVariableKey, o.value)}
                        />
                    </div>
                )}
            </div>
        )
    }

    removeQuestion = (question) => {
        const { chosenQuestions } = this.state
        const { chart } = this.props
        const chosenQuestionsClone = R.clone(chosenQuestions)
        const qIndex = chosenQuestionsClone
            .findIndex((cQ) => cQ.value.questionId === question.value.questionId)
        chosenQuestionsClone.splice(qIndex, 1)

        chart.removeVariable(question.value.questionId)

        this.setState({ chosenQuestions: chosenQuestionsClone })
    }

    testFormula = () => {
        const { chart, store } = this.props
        const { formulaScope } = this.state

        const testFormula = Object.keys(formulaScope).length
            ? chart.testFormula(formulaScope)
            : chart.testFormula()

        if (testFormula.success) {
            store.addNotification({ body: testFormula.message, level: 'success' })
        } else {
            store.handleError({ body: testFormula.message, level: 'error' })
        }
        this.setState({ testing: false })
    }

    renderAddQuestionsRow = (allowedQuestions) => {
        const {
            addingQuestion, newQuestion,
        } = this.state

        if (!allowedQuestions.length) return null

        return (
            <div style={{ display: 'flex' }}>
                <div style={{ paddingLeft: 0 }}>
                    {addingQuestion
                        ? (
                            <Select
                                options={allowedQuestions}
                                defaultValue={allowedQuestions[0].value}
                                onBlur={(q) => this.setState({
                                    newQuestion: { label: q.label, value: q.value },
                                })}
                            />
                        )
                        : null }
                </div>
                <div style={{ paddingRight: 0 }}>
                    {!addingQuestion
                        ? (
                            <Button
                                style={{ height: '47px' }}
                                className="regular primary"
                                onClick={() => this.setState({
                                    addingQuestion: true,
                                    newQuestion: {
                                        label: allowedQuestions[0].label,
                                        value: allowedQuestions[0].value,
                                    },
                                })}
                                label="Add Question"
                            />
                        )
                        : (
                            <Button
                                style={{ height: '47px' }}
                                className="regular primary"
                                onClick={() => (
                                    this.setState((prevState) => ({
                                        chosenQuestions: [
                                            ...prevState.chosenQuestions,
                                            newQuestion,
                                        ],
                                        addingQuestion: false,
                                        newQuestion: {},
                                    }))
                                )}
                                label="Add"
                            />
                        )}
                </div>
            </div>
        )
    }

    render() {
        const { chosenQuestions, testing } = this.state
        const { question, chart } = this.props
        const allowedQuestions = this.allowedQuestions()
        return (
            <Fragment>
                <div>
                    <div style={{ display: 'flex' }}>
                        {chosenQuestions.filter((q) => q.value.questionId !== question.id)
                            .map((q) => (
                                <div>
                                    <span
                                        style={{ marginRight: '5px' }}
                                        onClick={() => this.removeQuestion(q)}
                                    >
                                        <i className="fal fa-times-circle" />
                                    </span>
                                    {q.label}
                                </div>
                            ))}
                    </div>
                    {this.renderAddQuestionsRow(allowedQuestions)}
                    <div className="chartMath">{!testing ? 'Variable mapping' : 'Test variables'}</div>
                    {chosenQuestions.length ? this.renderVariableMapping() : null}
                    <div style={{ display: 'flex' }}>
                        <div>Formula</div>
                        <textarea
                            onBlur={(e) => chart.changeFormula(e.target.value)}
                            defaultValue={chart.formula || ''}
                            style={{ width: '100%', height: '75px' }}
                        />
                        <Button
                            style={{ float: 'right' }}
                            className="regular primary"
                            label={!testing ? 'Set test variables' : 'Test formula'}
                            onClick={testing
                                ? this.testFormula
                                : () => this.setState({ testing: true })}
                        />
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default ChartMath
